const parallaxStyle = theme =>({
  parallax: {
    height: "40vh",
    maxHeight: "1000px",
    overflow: "hidden",
    position: "relative",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    margin: "0",
    padding: "0",
    border: "0",
    display: "flex",
    alignItems: "center"
  },
  [theme.breakpoints.down("md")]: {
    parallax: {
      height: "50vh"
    }
  },
  [theme.breakpoints.down("xs")]: {
    parallax: {
      height: "55vh"
    }
  },

  filter: {
    "&:before": {
      background:"#2D5CA6", 
      // background: "linear-gradient(to top, #2D5CA6, #234161)",
      background:"radial-gradient(#2D5CA6, #234161)"
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  },
  small: {
    // height: "380px" //by default
    height: "160px"
  }
});

export default parallaxStyle;
